<template>
  <div id="playgame" class="tabcontent">
    <div class="headerprocess">
      <i class="fal fa-gamepad-alt"></i> เข้าเล่นเกม
    </div>
    <div class="containprocess" style="padding-top: 20px">
      <div class="d-flex justify-content-center">
        <table style="width: 85%">
          <tr>
            <td class="gameingtd" @click="selectMenu = 'all'">
              <div
                class="bkcolor2 tablinkgame"
                :class="{ active2: selectMenu === 'all' }"
              >
                <span><i class="fal fa-spade"></i> ทั้งหมด</span>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <table width="100%">
        <tr>
          <td class="gameingtd" @click="selectMenu = 'casino'">
            <div
              class="bkcolor tablinkgame"
              :class="{ active2: selectMenu === 'casino' }"
            >
              <span>
                <!-- <i class="fal fa-spade"></i> -->
                <img
                  src="../assets/icon/casino.webp"
                  width="25px"
                  height="25px"
                  alt=""
                />
                คาสิโน</span
              >
            </div>
          </td>
          <td class="gameingtd" @click="selectMenu = 'slot'">
            <div
              class="bkcolor tablinkgame"
              :class="{ active2: selectMenu === 'slot' }"
            >
              <span>
                <!-- <i class="fal fa-dice"></i> -->
                <img
                  src="../assets/icon/slot.webp"
                  width="25px"
                  height="25px"
                  alt=""
                />
                สล็อต</span
              >
            </div>
          </td>
          <td class="gameingtd" @click="selectMenu = 'fish'">
            <div
              class="bkcolor tablinkgame"
              :class="{ active2: selectMenu === 'fish' }"
            >
              <span>
                <!-- <i class="fal fa-fish"></i>  -->
                <img
                  src="../assets/icon/fishing.webp"
                  width="25px"
                  height="25px"
                  alt=""
                />
                ยิงปลา</span
              >
            </div>
          </td>
          <!-- <td class="gameingtd" @click="getSport">
            <div
              class="bkcolor tablinkgame"
              :class="{ active2: selectMenu === 'sport' }"
            >
              <span>
               <i class="fal fa-fish"></i> 
                <img
                  src="../assets/icon/sport.webp"
                  width="25px"
                  height="25px"
                  alt=""
                />
                กีฬา
              </span>
            </div>
          </td> -->
        </tr>
      </table>
      <div id="casino" class="tabgame">
        <div class="gridofgame" v-if="selectMenu === 'casino'">
          <div
            class="ingridgame" 
            v-for="(provider, index) in ProvidersCasino"
            :key="index"
          >
            <div
              class="iningridgame" v-bind:style="'background-image: '+createBackgroundString"
              @click="onClickPlay(provider.game)"
              v-if="provider.isOpen == 1"
            >
              <img :src="provider.logo" :alt="provider.name"/><br />{{
                provider.name
              }}
            </div>
            <div class="block-iningridgame" v-else>
              <img :src="provider.logo" :alt="provider.name"/><br />
              <div class="closed-game">ปิดปรับปรุง</div>
              {{ provider.name }}
            </div>
          </div>
        </div>
        <div class="gridofgame" v-else-if="selectMenu === 'slot'">
          <div
            class="ingridgame"
            v-for="(provider, index) in ProvidersSlot"
            :key="index"
          >
            <div
              class="iningridgame" v-bind:style="'background-image: '+createBackgroundString"
              @click="onClickPlay(provider.game)"
              v-if="provider.isOpen == 1"
            >
              <img :src="provider.logo" :alt="provider.name"/><br />{{
                provider.name
              }}
            </div>
            <div class="block-iningridgame" v-else>
              <img :src="provider.logo" :alt="provider.name"/><br />
              <div class="closed-game">ปิดปรับปรุง</div>
              {{ provider.name }}
            </div>
          </div>
        </div>
        <div class="gridofgame" v-else-if="selectMenu === 'fish'">
          <div
            class="ingridgame"
            v-for="(provider, index) in ProvidersFishing"
            :key="index"
          >
            <div
              class="iningridgame" v-bind:style="'background-image: '+createBackgroundString"
              @click="onClickPlay(provider.game)"
              v-if="provider.isOpen == 1"
            >
              <img :src="provider.logo" :alt="provider.name"/><br />{{
                provider.name
              }}
            </div>
            <div class="block-iningridgame" v-else>
              <img :src="provider.logo" :alt="provider.name"/><br />
              <div class="closed-game">ปิดปรับปรุง</div>
              {{ provider.name }}
            </div>
          </div>
        </div>
        <div
          class="gridofgame d-flex justify-content-center"
          v-else-if="selectMenu === 'sport'"
        >
          <div class="ingridgame" v-if="sport">
            <div v-for="(game, index) in GameFetch" :key="index">
              <div class="iningridgame" v-bind:style="'background-image: '+createBackgroundString" @click="enterUfa">
                <img src="../assets/images/ufabet.webp" alt="UFABET" /><br />UFA
                SPORT
              </div>
            </div>
          </div>
          <div class="block-iningridgame" v-else>
            <img src="../assets/images/ufabet.webp" alt="UFABET" /><br />
            <div class="closed-game-ufa">ปิดปรับปรุง</div>
            <span class="d-flex justify-content-center">UFA SPORT</span>
          </div>
        </div>
        <div class="gridofgame" v-else-if="selectMenu === 'game'">
          <div
            class="ingridgame"
            v-for="(game, index) in GameFetch"
            :key="index"
          >
            <div
              class="iningridgame" v-bind:style="'background-image: '+createBackgroundString"
              @click="EnterGame(game.provider, game.code)"
            >
              <img :src="getGameImg(game.img)" :alt="game.name" @error="handleGameImageError(game)"/><br />{{
                game.name
              }}
            </div>
          </div>
        </div>
        <div class="gridofgame" v-else>
          <div
            class="ingridgame"
            v-for="(provider, index) in Providers"
            :key="index"
          >
            <div
              class="iningridgame" v-bind:style="'background-image: '+createBackgroundString"
              @click="onClickPlay(provider.game)"
              v-if="provider.isOpen == 1"
            >
              <img :src="provider.logo" :alt="provider.name"/><br />{{
                provider.name
              }}
            </div>
            <div class="block-iningridgame" v-else>
              <img :src="provider.logo" :alt="provider.name"/><br />
              <div class="closed-game">ปิดปรับปรุง</div>
              {{ provider.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { HTTP } from "@/services/http-common";

export default {
  name: "game-component",
  data() {
    return {
      selectMenu: "all",
      sport: "",
      GameFetch: [],
      windowWidth: window.innerWidth,    
    };
  },
  methods: {
  handleGameImageError(game) {
    // Replace the game image source with a fallback image URL
    game.img = require('@/assets/icon/01.png');
  },
    getSport() {
      this.selectMenu = "sport";
      HTTP.get(`game/ufa/status`)
        .then((response) => {
          this.sport = response.data.ufa_status;
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
          );
        });
    },
    enterUfa() {
      if (this.sport == true) {
        this.EnterGameUfa();
      }
    },
    getGameImg(img) {
      if (img.charAt(0) === "/" && img.charAt(1) != "/") {
        return "https://ardmhzelxcmj.ocrazeckyunc.com" + img;
      } else {
        return img;
      }
    },
    onClickPlay(provider) {
      if (this.Auth.loggedIn) {
        if (
          provider === "we" ||
          provider === "xg" ||
          provider === "eg" ||
          provider === "cq9" ||
          provider === "r88" ||
          provider === "amb" ||
          provider === "gdg" ||
          provider === "ag" ||
          provider === "gd88" ||
          provider === "bg" ||
          provider === "ps" ||
          provider === "sp" ||
          provider === "ttg" ||
          provider === "sa" ||
          provider === "dg" ||
          provider === "sexy" ||
          provider === "wm" ||
          provider === "bfs" ||
          provider === "pg"
        ) {
          this.EnterGame(provider, "none");
        } else {
          let homeCont = this.$refs.homeCont;
          let loader = this.$loading.show({
            container: homeCont,
            loader: "Dots",
            color: "red",
            opacity: 0.5,
            backgroundColor: "#000000",
          });
          HTTP.post(`game/betflix/get-game`, {
            provider: provider,
          })
            .then((resp) => {
              if (resp.data.status) {
                if (resp.data.games != null) {
                  this.GameFetch = [];
                  this.GameFetch = resp.data.games;
                  this.selectMenu = "game";
                  // window.scrollTo(0, 0);
                }
              } else {
                this.$toast.error("ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่");
              }
            })
            .catch((err) => {
              this.$toast.error(err.data.msg);
            })
            .then(() => {
              loader.hide();
            });
        }
      } else {
        this.$refs.registerloginmodal.show("login");
      }
    },
    // GET URL LAUNCH GAME FROM API
    EnterGame(provider, gamecode) {
      let url = this.$router.resolve({
        path: `/loading-game/${provider}/${gamecode}`,
      });
      window.open(url.href, "_blank");
      // if (this.Auth.userBetflix != "") {
      //   //   let wintab = window.open("", "_blank");
      //   HTTP.post(
      //     `game/betflix/enter`,
      //     {
      //       provider: this.CheckProvider(provider),
      //       gamecode: gamecode,
      //       redirectUrl: "https://betflix.co/gameboard/",
      //     }
      //     // {
      //     //   headers: {
      //     //     Authorization: "Bearer " + localStorage.getItem("lb_token"),
      //     //   },
      //     // }
      //   )
      //     .then((resp) => {
      //       if (this.windowWidth < 768) {
      //         setTimeout(
      //           () => window.open(resp.data.game.launch_url, "_self"),
      //           1000
      //         );
      //       } else {
      //         setTimeout(
      //           () => window.open(resp.data.game.launch_url, "_blank"),
      //           1000
      //         );
      //       }
      //       // setTimeout(
      //       //   () => (wintab.location = resp.data.game.launch_url),
      //       //   1000
      //       // );
      //     })
      //     .catch((err) => {
      //       // if (err.response) {
      //       //   if (err.response.status === 401) {
      //       //     this.$store.dispatch("logoutAuth");
      //       //   } else {
      //       this.$toast.error(
      //         err.data.msg != undefined
      //           ? err.data.msg
      //           : "ไม่สามารถเข้าเล่นเกมได้ กรุณาลองใหม่"
      //       );
      //       //   }
      //       // }
      //     });
      // } else {
      //   this.$toast.error("เกมปิดปรับปรุงชั่วคราว");
      // }
    },
    EnterGameUfa() {
      if (this.Auth.loggedIn) {
        let url = this.$router.resolve({
          path: `/loading-game/sport/ufa`,
        });
        window.open(url.href, "_blank");
      }
      // if (this.Auth.loggedIn) {
      //   // _self
      //   HTTP.get(`game/ufa/enter`)
      //     .then((resp) => {
      //       if (this.windowWidth < 768) {
      //         setTimeout(
      //           () => window.open(resp.data.game.gameUrl, "_self"),
      //           1000
      //         );
      //       } else {
      //         setTimeout(
      //           () => window.open(resp.data.game.gameUrl, "_blank"),
      //           1000
      //         );
      //       }
      //     })
      //     .catch((err) => {
      //       this.$toast.error(
      //         err.data.msg != undefined
      //           ? err.data.msg
      //           : "ไม่สามารถเข้าเล่นเกมได้ กรุณาลองใหม่"
      //       );
      //     });
      // } else {
      //   this.$refs.registerloginmodal.show("login");
      // }
      // let url = this.$router.resolve({
      //   path: `/loading-game/${provider}/${gamecode}`,
      // });
      // window.open(url.href, "_blank");
    },
    CheckProvider(provider) {
      if (
        provider === "BPG" ||
        provider === "BNG" ||
        provider === "HAB" ||
        provider === "KGL" ||
        provider === "RLX" ||
        provider === "YGG" ||
        provider === "RED" ||
        provider === "QS" ||
        provider === "IDS" ||
        provider === "TK" ||
        provider === "MAV" ||
        provider === "DS" ||
        provider === "NLC" ||
        provider === "GA" ||
        provider === "PNG" ||
        provider === "PUG" ||
        provider === "FNG" ||
        provider === "NGE" ||
        provider === "1X2" ||
        provider === "HAK" ||
        provider === "WAZ" ||
        provider === "ELK" ||
        provider === "ng" ||
        provider === "bs" ||
        provider === "PRS"
      ) {
        return "qtech";
      } else {
        return provider;
      }
    },
  },
  computed: {
    ...mapGetters(["Providers"]),
    ...mapGetters(["ProvidersCasino"]),
    ...mapGetters(["ProvidersSlot"]),
    ...mapGetters(["ProvidersFishing"]),
    ...mapGetters(["Auth"]),
    ...mapGetters(["WebSetting"]),
    createBackgroundString() {
      return `linear-gradient(170deg, ${this.WebSetting.color1} 0%, #000516 100%);`;
    },
  },
};
</script>

<style></style>
